"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFredhopperCampaigns = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const campaignEndpoints = {
    getFredhopperCampaigns: {
        client: 'api/campaign/search?mainWebShop={mainWebshop}&locale={locale}&pageType=basket',
    },
};
const getFredhopperCampaigns = (_a, locale_1) => tslib_1.__awaiter(void 0, [_a, locale_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, locale) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, campaignEndpoints.getFredhopperCampaigns, isServer, {
        mainWebshop: defaultRequestParams.mainWebshop,
        locale,
    });
    const axiosConfig = {
        method: 'GET',
        url,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getFredhopperCampaigns = getFredhopperCampaigns;
//# sourceMappingURL=campaign.api.js.map